// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuideRouteImport } from './routes/$guide'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AlphaGalRouteImport } from './routes/alpha-gal'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as MapRouteImport } from './routes/map'
import { Route as PreventionRouteImport } from './routes/prevention'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SourcesRouteImport } from './routes/sources'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TickBiteGuideRouteImport } from './routes/tick-bite-guide'
import { Route as TickBiteToolRouteImport } from './routes/tick-bite-tool'
import { Route as TickIdentificationRouteImport } from './routes/tick-identification'
import { Route as DiseasesIndexRouteImport } from './routes/diseases.index'
import { Route as DiseasesDiseaseRouteImport } from './routes/diseases.$disease'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesSlugRouteImport } from './routes/resources.$slug'
import { Route as StatesIndexRouteImport } from './routes/states.index'
import { Route as StatesStateRouteImport } from './routes/states.$state'
import { Route as TicksIndexRouteImport } from './routes/ticks.index'
import { Route as TicksSpeciesRouteImport } from './routes/ticks.$species'
import { Route as StatesStateCountyRouteImport } from './routes/states.$state_.$county'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/$guide',path: '/$guide',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AlphaGalRoute = AlphaGalRouteImport.update({
            id: '/alpha-gal',path: '/alpha-gal',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const PreventionRoute = PreventionRouteImport.update({
            id: '/prevention',path: '/prevention',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SourcesRoute = SourcesRouteImport.update({
            id: '/sources',path: '/sources',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TickBiteGuideRoute = TickBiteGuideRouteImport.update({
            id: '/tick-bite-guide',path: '/tick-bite-guide',getParentRoute: () => rootRouteImport
          })
const TickBiteToolRoute = TickBiteToolRouteImport.update({
            id: '/tick-bite-tool',path: '/tick-bite-tool',getParentRoute: () => rootRouteImport
          })
const TickIdentificationRoute = TickIdentificationRouteImport.update({
            id: '/tick-identification',path: '/tick-identification',getParentRoute: () => rootRouteImport
          })
const DiseasesIndexRoute = DiseasesIndexRouteImport.update({
            id: '/diseases/',path: '/diseases/',getParentRoute: () => rootRouteImport
          })
const DiseasesDiseaseRoute = DiseasesDiseaseRouteImport.update({
            id: '/diseases/$disease',path: '/diseases/$disease',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })
const StatesIndexRoute = StatesIndexRouteImport.update({
            id: '/states/',path: '/states/',getParentRoute: () => rootRouteImport
          })
const StatesStateRoute = StatesStateRouteImport.update({
            id: '/states/$state',path: '/states/$state',getParentRoute: () => rootRouteImport
          })
const TicksIndexRoute = TicksIndexRouteImport.update({
            id: '/ticks/',path: '/ticks/',getParentRoute: () => rootRouteImport
          })
const TicksSpeciesRoute = TicksSpeciesRouteImport.update({
            id: '/ticks/$species',path: '/ticks/$species',getParentRoute: () => rootRouteImport
          })
const StatesStateCountyRoute = StatesStateCountyRouteImport.update({
            id: '/states/$state_/$county',path: '/states/$state/$county',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,GuideRoute: GuideRoute,AboutRoute: AboutRoute,AlphaGalRoute: AlphaGalRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DisclaimerRoute: DisclaimerRoute,MapRoute: MapRoute,PreventionRoute: PreventionRoute,PrivacyRoute: PrivacyRoute,SourcesRoute: SourcesRoute,TermsRoute: TermsRoute,TickBiteGuideRoute: TickBiteGuideRoute,TickBiteToolRoute: TickBiteToolRoute,TickIdentificationRoute: TickIdentificationRoute,DiseasesDiseaseRoute: DiseasesDiseaseRoute,ResourcesSlugRoute: ResourcesSlugRoute,StatesStateRoute: StatesStateRoute,TicksSpeciesRoute: TicksSpeciesRoute,DiseasesIndexRoute: DiseasesIndexRoute,ResourcesIndexRoute: ResourcesIndexRoute,StatesIndexRoute: StatesIndexRoute,TicksIndexRoute: TicksIndexRoute,StatesStateCountyRoute: StatesStateCountyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)